import { fetchProductLink } from 'api/productLinks';
import useAxios from 'hooks/useAxios';
import { IProductResource } from '../../server/types';

const useFetchProductLink = () => {
  const [request, { loading, error }] = useAxios<{ products: IProductResource[] }>();
  const handleFetchProduct = (productName: string) => request(fetchProductLink(productName));
  return [handleFetchProduct, { loading, error }] as const;
};

export { useFetchProductLink };
